import { Link } from "react-router-dom";
import { Mail, MapPin, Linkedin, Github } from "lucide-react";
import { industries } from "@/data/industries";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#050505]"
    >
      <div className="noise-overlay" />
      <div className="container-x py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10 relative">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 grid place-items-center rounded-md bg-[#00F0FF] text-black font-display text-lg font-bold">
              P
            </div>
            <div>
              <div className="font-display text-xl">Pransam</div>
              <div className="font-mono-label text-[10px] text-[#00F0FF]">
                TECHNOLOGIES LLP
              </div>
            </div>
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            AI, product engineering and applied research — for teams
            operationalising intelligence across manufacturing, pharma,
            education and agritech.
          </p>

          <div className="mt-6 flex items-center gap-3">
            <a
              href="mailto:contact@pransam.com"
              data-testid="footer-email-link"
              className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-[#00F0FF] transition-colors"
            >
              <Mail size={14} /> contact@pransam.com
            </a>
          </div>
          <div className="mt-2 flex items-center gap-2 text-sm text-white/50">
            <MapPin size={14} /> Bengaluru, India
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono-label text-[11px] text-[#00F0FF] mb-4">
            Company
          </div>
          <ul className="space-y-3 text-sm text-white/70">
            <li>
              <Link
                to="/about"
                data-testid="footer-link-about"
                className="hover:text-white"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                data-testid="footer-link-services"
                className="hover:text-white"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/insights"
                data-testid="footer-link-insights"
                className="hover:text-white"
              >
                Insights
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                data-testid="footer-link-contact"
                className="hover:text-white"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono-label text-[11px] text-[#00F0FF] mb-4">
            Industries
          </div>
          <ul className="space-y-3 text-sm text-white/70">
            {industries.map((i) => (
              <li key={i.slug}>
                <Link
                  to={`/industries/${i.slug}`}
                  data-testid={`footer-industry-${i.slug}`}
                  className="hover:text-white"
                >
                  {i.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} Pransam Technologies LLP. All rights
            reserved.
          </div>
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-linkedin"
              className="hover:text-white transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={16} />
            </a>
            <a
              href="https://github.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-github"
              className="hover:text-white transition-colors"
              aria-label="GitHub"
            >
              <Github size={16} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
